import { EMLogo } from "@/components/logo/EMLogo";
import {
  CLEAN_HEAT_PARTNERS_CUSTOM_URL_HOST,
  CLEAN_HEAT_PARTNERS_ORGANIZATION_ID,
  ENERGY_MACHINES_CUSTOM_URL_HOST,
  ENERGY_MACHINES_ORGANIZATION_ID,
  SIMULATE_ENERGY_MACHINES_CUSTOM_URL_HOST,
  SIMULATE_ENERGY_MACHINES_ORGANIZATION_ID,
  WEDOSCM_CUSTOM_URL_HOST
} from "./BrandLabelConstants";
import emFavIcon from "./brand-favicons/em-fave.ico";
import { CleanHeatPartnersLogo } from "./clean-heat-partners/CleanHeatPartnersLogo";
import cleanHeatPartnersFavIcon from "./clean-heat-partners/clean-heat-partners-fav.ico";
import Brandmark from "@/components/logo/Brandmark";

export type WhiteLabelBrand = {
  id?: string;
  name: string;
  hostname: string;
  cookieDomain: string;
  brandWebsite: string;
  title: string;
  Logo: () => JSX.Element;
  favIcon: string;
};

const WhiteLabelBrands: Readonly<{ [key: string]: WhiteLabelBrand }> =
  Object.freeze({
    [SIMULATE_ENERGY_MACHINES_CUSTOM_URL_HOST]: {
      id: SIMULATE_ENERGY_MACHINES_ORGANIZATION_ID,
      hostname: SIMULATE_ENERGY_MACHINES_CUSTOM_URL_HOST,
      cookieDomain: ".energymachines.com",
      name: "energy-machines",
      brandWebsite: "https://www.energymachines.com/",
      title: "Energy Machines",
      Logo: EMLogo,
      favIcon: emFavIcon
    },
    [ENERGY_MACHINES_CUSTOM_URL_HOST]: {
      id: ENERGY_MACHINES_ORGANIZATION_ID,
      hostname: ENERGY_MACHINES_CUSTOM_URL_HOST,
      cookieDomain: ".energymachines.com",
      name: "energy-machines",
      brandWebsite: "https://www.energymachines.com/",
      title: "Energy Machines",
      Logo: EMLogo,
      favIcon: emFavIcon
    },
    [CLEAN_HEAT_PARTNERS_CUSTOM_URL_HOST]: {
      id: CLEAN_HEAT_PARTNERS_ORGANIZATION_ID,
      hostname: CLEAN_HEAT_PARTNERS_CUSTOM_URL_HOST,
      cookieDomain: ".cleanheatpartners.com",
      name: "clean-heat-partners",
      brandWebsite: "https://www.cleanheatpartners.com/",
      title: "Clean Heat Partners",
      Logo: CleanHeatPartnersLogo,
      favIcon: cleanHeatPartnersFavIcon
    },
    [WEDOSCM_CUSTOM_URL_HOST]: {
      id: undefined,
      hostname: WEDOSCM_CUSTOM_URL_HOST,
      cookieDomain: ".wedoscm.com",
      name: "wedoscm",
      brandWebsite: "https://www.wedoscm.com/",
      title: "WeDoSCM",
      Logo: Brandmark,
      favIcon: ""
    }
  });

export const getWhiteLabelBrand = () => {
  const host = window.location.hostname;

  if (host in WhiteLabelBrands) return WhiteLabelBrands[host];
  return undefined;
};
